import React, { useCallback, useEffect, useState } from "react";
import AddCard from "./AddCard";
import { API, fileUpload } from "../../config";
import { useOrganization } from "../../lib/context/OrganisationContext";
import MainBody from "../../components/MainBody/MainBody";
import { Button } from "../../components/ui/button";
import { cn } from "../../lib/utils";
import { Switch } from "../../components/ui/switch";
import Spin from "../../components/Spin";

const CardDetail = () => {
  const [loading, setLoading] = useState(false);
  const { organizationData } = useOrganization();
  const [fetchLoading, setFetchLoading] = useState(false);
  const [showAddCard, setShowAddCard] = useState(null);

  const [cards, setCards] = useState([]);

  const toggleAddCard = () => {
    setShowAddCard(!showAddCard);
  };

  const fetchCardDetails = useCallback(async () => {
    try {
      setFetchLoading(true);
      const formData = new FormData();
      formData.append(`organization_id`, organizationData?.organizationId);
      const response = await fileUpload(`${API.GET_PAYMENT_METHODS}`, formData);

      if (response?.data?.data) {
        setCards(response?.data?.data);
        // toast.success(response.data.message);
      }
    } catch (error) {
      setFetchLoading(false);
    } finally {
      setFetchLoading(false);
    }
  }, [organizationData?.organizationId]);

  useEffect(() => {
    fetchCardDetails();
  }, [fetchCardDetails]);

  const handleDefault = async (card) => {
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append(
        "organization_id",
        organizationData?.organizationId || "",
      );
      formData.append("payment_method_id", card?.id || "");
      formData.append("customer_id", card?.customer_id);
      formData.append("default", true);
      formData.append("type", 0);
      formData.append("_method", "put");

      const { data } = await fileUpload(API.GET_PAYMENT_METHODS, formData);
      if (data) {
        fetchCardDetails();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  return (
    <MainBody
      search={false}
      actionContent={""}
      loading={false}
      className={"bg-transparent p-0 rounded-lg dark:bg-transparent"}
      expandList={true}
    >
      <div className="space-y-4">
        <div className="flex justify-between">
          <p>Kindly note that virtual cards are not accepted.</p>
          <Button onClick={toggleAddCard}>Add New</Button>
        </div>

        {(loading || fetchLoading) && <Spin expand={true} />}

        {/* <div className="bg-muted p-4 rounded-xl shadow-sm space-y-4"> */}
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
            {cards.length > 0 ? (
              cards.map((card, index) => (
                <div
                  key={card.card_id}
                  className={cn(
                    "relative rounded-xl border p-2.5 shadow-sm transition-colors min-h-[135px]",
                    "bg-white border-muted dark:border-zinc-700",
                    card.default
                      ? "ring-2 ring-webPrimary"
                      : "ring-1 ring-border",
                  )}
                >
                  <p className="text-sm font-semibold mb-2 text-black">
                    Card - {index + 1} ({card?.brand})
                  </p>

                  {/* Card UI */}
                  <div className="relative rounded-lg p-4 space-y-2 bg-gradient-to-br from-gray-700 to-gray-900 dark:from-zinc-800 dark:to-zinc-900 text-white">
                    <div className="flex items-center justify-between">
                      <div className="h-5 w-8 bg-yellow-400 rounded-sm" />
                      <Switch
                        id={`switch-${card.id}`}
                        checked={card.default}
                        onCheckedChange={() => handleDefault(card)}
                        disabled={card.default}
                        className="data-[state=checked]:bg-webPrimary"
                      />
                    </div>

                    <div className="text-lg font-mono tracking-widest mt-2">
                      •••• •••• •••• {card.last4}
                    </div>

                    <div className="flex justify-between text-sm mt-3 text-white">
                      <span className="text-white">{card.brand}</span>
                      <span className="text-white">Exp: {card?.expiry}</span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-left text-muted-foreground italic">
                No cards are added
              </p>
            )}
          </div>

          {showAddCard && (
            <AddCard
              showAddCard={showAddCard}
              toggleAddCard={toggleAddCard}
              fetchCardDetails={fetchCardDetails}
              cards={cards}
              setShowAddCard={setShowAddCard}
            />
          )}
        </div>
      </div>
    </MainBody>
  );
};

export default CardDetail;
